import TimeoutGuard from './container'

export default TimeoutGuard
